<template lang="pug">
Card.dashBoardCard
    Row(flex justify="end")
        Button(@click="showCacheStatusLineChart = !showCacheStatusLineChart") {{ showCacheStatusLineChartBtnText }}
    div(style="display: grid; position: relative")
        div(:style="statusContentStyle")
            LineChartWrapper(
                key="cache-status-line-chart"
                :chartType="'cacheStatusLineChart'"
                :chartDataSetLabel="['dashboard.dataCachedUsage', 'dashboard.dataServedUsage']"
                :titleDisplay="false"
                :numeralFormat="'0.00ib'"
                :withCard="false"
                :linePointRadius="[4, 4]"
                :linePointHoverRadius="[8, 8]"
                :linePointBackgroundColor="['white', 'white']"
                :linePointBorderWidth="[3, 3]"
                :lineBorderColors="[colorScheme.green.border, colorScheme.blue.border]"
                :lineBackgroundGradientStops="[colorScheme.green.gradientStops, colorScheme.blue.gradientStops]"
                :linePointHoverBorderWidth="[5, 5]"
                :linePointHoverBorderColor="['rgba(152, 202, 235, 0.5)', 'rgba(152, 202, 235, 0.5)']"
                :linePointHoverBackgroundColor="['white', 'white']"
                :isPointStyle="$store.getters.getChartConfig.legendPointStyle"
                :isSetDataToStore="isSetDataToStore"
                :apiEndpoint="apiEndpoint"
            )
            SingleNumWrapper(
                key="served-sum-num"
                :class="showRawBtnStyle == 'iconBtn' ? 'underLineChartWrapper' : ''"
                :chartType="'servedsumnum'"
                :chartTitle="$t('dashboard.dataServedUsage')"
                :numeralFormat="'0.00ib'"
                :withCard="false"
                :textInSingleLine="true"
                :maxFontSize="'16px'"
                style="text-align: right"
                :apiEndpoint="apiEndpoint"
            )
            SingleNumWrapper(
                key="served-byte-rate-num"
                :class="showRawBtnStyle == 'iconBtn' ? 'underLineChartWrapper' : ''"
                :chartType="'servedByteRateNum'"
                :chartTitle="$t('dashboard.avgServedSpeedRate')"
                :numeralFormat="'0.00b'"
                :numStringSuffix="' / s'"
                :withCard="false"
                :textInSingleLine="true"
                :maxFontSize="'16px'"
                style="text-align: right"
                :apiEndpoint="apiEndpoint"
            )
        div(v-if="!showCacheStatusLineChart" style="grid-area: 1 / 1; min-width: 0")
            LineChartWrapper(
                key="cache-ratio-line-chart"
                :chartType="'cacheRatioLineChart'"
                :chartDataSetLabel="['dashboard.cacheRatioText']"
                :titleDisplay="false"
                :numeralFormat="'0%'"
                :withCard="false"
                :linePointRadius="[4]"
                :linePointHoverRadius="[8]"
                :linePointBackgroundColor="['white']"
                :linePointBorderWidth="[3]"
                :lineBorderColors="[colorScheme.green.border]"
                :lineBackgroundGradientStops="[colorScheme.green.gradientStops]"
                :linePointHoverBorderWidth="[5]"
                :linePointHoverBorderColor="['rgba(152, 202, 235, 0.5)']"
                :linePointHoverBackgroundColor="['white']"
                :isPointStyle="$store.getters.getChartConfig.legendPointStyle"
                :sourceData="$store.getters.chartData_cacheRatioSeries"
            )
</template>
<script>
import LineChartWrapper from "@/components/dashboard/LineChartWrapper";
import SingleNumWrapper from "@/components/dashboard/SingleNumWrapper";
import colorScheme from "@/data/colorScheme";

export default {
    name: "CacheLineChartSet",
    props: {
        apiEndpoint: {
            default: () => "",
        },
    },
    components: {
        LineChartWrapper,
        SingleNumWrapper,
    },
    data() {
        return {
            showCacheStatusLineChart: true,
            colorScheme: colorScheme,
            isSetDataToStore: true,
        };
    },
    computed: {
        statusContentStyle() {
            return this.showCacheStatusLineChart
                ? { gridArea: "1 / 1", minWidth: 0 }
                : { gridArea: "1 / 1", minWidth: 0, visibility: "hidden", pointerEvents: "none" };
        },
        showRawBtnStyle() {
            return this.$store.getters.getChartConfig.showRawBtnStyle;
        },
        showCacheStatusLineChartBtnText() {
            return this.showCacheStatusLineChart
                ? this.$i18n.t("dashboard.showCacheRatio")
                : this.$i18n.t("dashboard.showCacheStatus");
        },
    },
};
</script>



// WEBPACK FOOTER //
// src/components/dashboard/CacheLineChartSet.vue